import { NgModule } from '@angular/core';

import { Routes, RouterModule } from '@angular/router';

import { CambiarPasswordComponent } from './account/cambiar-password/cambiar-password.component';

import { AuthenticatedShellComponent } from './shells/authenticated/authenticated-shell.component';

import { LayoutComponent } from './shells/public/layout/layout.component';

import { LoginComponent } from './auth/login/login.component';

import { NotificacionesComponent } from './account/notificaciones/notificaciones.component';

import { P404Component } from './shells/system/p404/p404.component';

import { PerfilUsuarioComponent } from './account/perfil-usuario/perfil-usuario.component';

import { RecoverpasswordComponent } from './auth/recoverpassword/recoverpassword.component';

import { UnauthorizedComponent } from './shells/system/unauthorized/unauthorized.component';

import { AuthGuardService } from './services/auth/helpers/auth-guard.service';

import { SolicitarClaveComponent } from './auth/solicitar-clave/solicitar-clave.component';

import { AppComponent } from './app.component';

import { PedidoPendienteComponent } from './profiles/aridos-mixer/despacho/components/pedido-pendiente.component';

import { PedidoPendienteDetalleComponent } from './profiles/aridos-mixer/despacho/components/pedido-pendiente-detalle/pedido-pendiente-detalle.component';
import { ProfileRouteMatchGuard } from 'src/core/navigation/profile-route-match.guard';
import { HormigonPedidoPendienteComponent } from './profiles/hormigon-mixer/despacho/components/pedido-pendiente.component';
import { HormigonOtrosDespachosComponent } from './profiles/hormigon-mixer/otros-despachos/hormigon-otros-despachos.component';
import { HormigonFirmaDigitalPageComponent } from './profiles/hormigon-mixer/despacho/firma-digital-page/hormigon-firma-digital-page.component';
import { HormigonMixerDashboardEntryComponent } from './profiles/hormigon-mixer/dashboard/hormigon-mixer-dashboard-entry.component';
import { AridosMixerDashboardEntryComponent } from './profiles/aridos-mixer/dashboard/aridos-mixer-dashboard-entry.component';
import { HormigonMixerHistoryEntryComponent } from './profiles/hormigon-mixer/historial/hormigon-mixer-history-entry.component';
import { AridosMixerHistoryEntryComponent } from './profiles/aridos-mixer/historial/aridos-mixer-history-entry.component';
import { OperatorRouteRedirectComponent } from './shells/authenticated/operator-route-redirect.component';





const routes: Routes = [

  {
    path: 'Seguimiento',
    data: { executionChannel: 'anonymous', owner: 'anonymous-shared' },
    loadChildren: () =>
      import('./profiles/anonymous/anonymous.module').then(
        (m) => m.AnonymousModule
      ),
  },

  {
    path: 'seguimiento-anonimo',
    data: { executionChannel: 'anonymous', owner: 'anonymous-shared' },
    loadChildren: () =>
      import('./profiles/anonymous/anonymous.module').then(
        (m) => m.AnonymousModule
      ),
  },

  {



    path: '',

    component: LayoutComponent,

    children: [

      { path: '', component: LoginComponent, pathMatch: 'full' },

      { path: 'login', component: LoginComponent, pathMatch: 'full' },

      { path: 'unauthorized', component: UnauthorizedComponent },

      { path: 'recoverpassword', component: RecoverpasswordComponent },



    ]

  },

  {

    path: '',

    component: AppComponent,

    children: [

      { path: 'solicitarclave', component: SolicitarClaveComponent },

    ]

  },

  {

    path: '',

    component: AuthenticatedShellComponent,

    children: [

      { path: '', component: LoginComponent, pathMatch: 'full', canActivate: [AuthGuardService] },

      {
        path: 'dashboard',
        component: HormigonMixerDashboardEntryComponent,
        canMatch: [ProfileRouteMatchGuard],
        canActivate: [AuthGuardService],
        data: {
          executionChannel: 'authenticated',
          owner: 'HORMIGON_MIXER',
          allowedProfiles: ['HORMIGON_MIXER'],
          allowOperatorFallback: false,
        },
      },

      {
        path: 'dashboard',
        component: AridosMixerDashboardEntryComponent,
        canMatch: [ProfileRouteMatchGuard],
        canActivate: [AuthGuardService],
        data: {
          executionChannel: 'authenticated',
          owner: 'ARIDOS_MIXER',
          allowedProfiles: ['ARIDOS_MIXER'],
          allowOperatorFallback: false,
        },
      },

      {
        path: 'dashboard',
        component: OperatorRouteRedirectComponent,
        canMatch: [ProfileRouteMatchGuard],
        canActivate: [AuthGuardService],
        data: {
          executionChannel: 'authenticated',
          owner: 'operator-profiles',
          allowedProfiles: ['HORMIGON_OPERADOR_PLANTA', 'ARIDOS_OPERADOR_PLANTA'],
          allowOperatorFallback: false,
        },
      },

      {
        path: 'editarperfil',
        component: PerfilUsuarioComponent,
        canActivate: [AuthGuardService],
        data: { executionChannel: 'authenticated', owner: 'authenticated-shell' },
      },

      {
        path: 'cambiarpassword',
        component: CambiarPasswordComponent,
        canActivate: [AuthGuardService],
        data: { executionChannel: 'authenticated', owner: 'authenticated-shell' },
      },

      {
        path: 'notificaciones',
        component: NotificacionesComponent,
        canActivate: [AuthGuardService],
        data: { executionChannel: 'authenticated', owner: 'authenticated-shell' },
      },

      {
        path: 'pedidospendiente',
        component: HormigonPedidoPendienteComponent,
        canMatch: [ProfileRouteMatchGuard],
        canActivate: [AuthGuardService],
        data: {
          executionChannel: 'authenticated',
          owner: 'HORMIGON_MIXER',
          allowedProfiles: ['HORMIGON_MIXER'],
          allowOperatorFallback: false,
        },
      },

      {
        path: 'otrosdespachos',
        component: HormigonOtrosDespachosComponent,
        canMatch: [ProfileRouteMatchGuard],
        canActivate: [AuthGuardService],
        data: {
          executionChannel: 'authenticated',
          owner: 'HORMIGON_MIXER',
          allowedProfiles: ['HORMIGON_MIXER'],
          allowOperatorFallback: false,
        },
      },

      {
        path: 'pedidospendiente/detalle',
        component: HormigonFirmaDigitalPageComponent,
        canMatch: [ProfileRouteMatchGuard],
        canActivate: [AuthGuardService],
        data: {
          executionChannel: 'authenticated',
          owner: 'HORMIGON_MIXER',
          allowedProfiles: ['HORMIGON_MIXER'],
          allowOperatorFallback: false,
        },
      },

      {
        path: 'otrosdespachos/detalle',
        component: HormigonFirmaDigitalPageComponent,
        canMatch: [ProfileRouteMatchGuard],
        canActivate: [AuthGuardService],
        data: {
          executionChannel: 'authenticated',
          owner: 'HORMIGON_MIXER',
          allowedProfiles: ['HORMIGON_MIXER'],
          allowOperatorFallback: false,
        },
      },

      {
        path: 'pedidospendiente',
        component: PedidoPendienteComponent,
        canMatch: [ProfileRouteMatchGuard],
        canActivate: [AuthGuardService],
        data: {
          executionChannel: 'authenticated',
          owner: 'ARIDOS_MIXER',
          allowedProfiles: ['ARIDOS_MIXER'],
          allowOperatorFallback: false,
        },
      },

      {
        path: 'pedidospendiente',
        component: OperatorRouteRedirectComponent,
        canMatch: [ProfileRouteMatchGuard],
        canActivate: [AuthGuardService],
        data: {
          executionChannel: 'authenticated',
          owner: 'operator-profiles',
          allowedProfiles: ['HORMIGON_OPERADOR_PLANTA', 'ARIDOS_OPERADOR_PLANTA'],
          allowOperatorFallback: false,
        },
      },

      {
        path: 'PedidosPendientes/Detalle',
        component: HormigonFirmaDigitalPageComponent,
        canMatch: [ProfileRouteMatchGuard],
        canActivate: [AuthGuardService],
        data: {
          executionChannel: 'authenticated',
          owner: 'HORMIGON_MIXER',
          allowedProfiles: ['HORMIGON_MIXER'],
          allowOperatorFallback: false,
        },
      },

      {
        path: 'PedidosPendientes/Detalle',
        component: PedidoPendienteDetalleComponent,
        canMatch: [ProfileRouteMatchGuard],
        canActivate: [AuthGuardService],
        data: {
          executionChannel: 'authenticated',
          owner: 'ARIDOS_MIXER',
          allowedProfiles: ['ARIDOS_MIXER'],
          allowOperatorFallback: false,
        },
      },

      {
        path: 'PedidosPendientes/Detalle',
        component: OperatorRouteRedirectComponent,
        canMatch: [ProfileRouteMatchGuard],
        canActivate: [AuthGuardService],
        data: {
          executionChannel: 'authenticated',
          owner: 'operator-profiles',
          allowedProfiles: ['HORMIGON_OPERADOR_PLANTA', 'ARIDOS_OPERADOR_PLANTA'],
          allowOperatorFallback: false,
        },
      },

      {
        path: 'fatiga',
        loadChildren: () =>
          import('./profiles/hormigon-mixer/fatiga/fatiga.module').then((m) => m.FatigaModule),
        canActivate: [AuthGuardService],
        data: {
          executionChannel: 'authenticated',
          owner: 'HORMIGON_MIXER',
          allowedProfiles: ['HORMIGON_MIXER'],
        },
      },

      {
        path: 'pedidosEntregados',
        component: HormigonMixerHistoryEntryComponent,
        canMatch: [ProfileRouteMatchGuard],
        canActivate: [AuthGuardService],
        data: {
          executionChannel: 'authenticated',
          owner: 'HORMIGON_MIXER',
          allowedProfiles: ['HORMIGON_MIXER'],
          allowOperatorFallback: false,
        },
      },

      {
        path: 'pedidosEntregados',
        component: AridosMixerHistoryEntryComponent,
        canMatch: [ProfileRouteMatchGuard],
        canActivate: [AuthGuardService],
        data: {
          executionChannel: 'authenticated',
          owner: 'ARIDOS_MIXER',
          allowedProfiles: ['ARIDOS_MIXER'],
          allowOperatorFallback: false,
        },
      },

      {
        path: 'pedidosEntregados',
        component: OperatorRouteRedirectComponent,
        canMatch: [ProfileRouteMatchGuard],
        canActivate: [AuthGuardService],
        data: {
          executionChannel: 'authenticated',
          owner: 'operator-profiles',
          allowedProfiles: ['HORMIGON_OPERADOR_PLANTA', 'ARIDOS_OPERADOR_PLANTA'],
          allowOperatorFallback: false,
        },
      },

      {
        path: 'checklist',
        loadChildren: () =>
          import('./profiles/hormigon-mixer/checklist/checklist.module').then(
            (m) => m.ChecklistModule
          ),
        canActivate: [AuthGuardService],
        data: {
          executionChannel: 'authenticated',
          owner: 'HORMIGON_MIXER',
          allowedProfiles: ['HORMIGON_MIXER'],
        },
      },

      {
        path: 'hormigon/controlCombustible',
        loadChildren: () =>
          import('./profiles/hormigon-operador-planta/combustible/hormigon-combustible.module').then(
            (m) => m.HormigonCombustibleModule
          ),
        canMatch: [ProfileRouteMatchGuard],
        canActivate: [AuthGuardService],
        data: {
          executionChannel: 'authenticated',
          owner: 'HORMIGON_OPERADOR_PLANTA',
          allowedProfiles: ['HORMIGON_OPERADOR_PLANTA'],
          allowOperatorFallback: false,
        },
      },

      {
        path: 'hormigon-operador-planta/cierre-diario',
        loadChildren: () =>
          import('./profiles/hormigon-operador-planta/cierre-diario/hormigon-cierre-diario.module').then(
            (m) => m.HormigonCierreDiarioModule
          ),
        canMatch: [ProfileRouteMatchGuard],
        canActivate: [AuthGuardService],
        data: {
          executionChannel: 'authenticated',
          owner: 'HORMIGON_OPERADOR_PLANTA',
          allowedProfiles: ['HORMIGON_OPERADOR_PLANTA'],
          allowOperatorFallback: false,
        },
      },

      {
        path: 'aridos/controlCombustible',
        loadChildren: () =>
          import('./profiles/aridos-operador-planta/combustible/aridos-combustible.module').then(
            (m) => m.AridosCombustibleModule
          ),
        canMatch: [ProfileRouteMatchGuard],
        canActivate: [AuthGuardService],
        data: {
          executionChannel: 'authenticated',
          owner: 'ARIDOS_OPERADOR_PLANTA',
          allowedProfiles: ['ARIDOS_OPERADOR_PLANTA'],
          allowOperatorFallback: false,
        },
      },



    ]

  },

  { path: '**', component: P404Component },





];



@NgModule({

  imports: [RouterModule.forRoot(routes)],

  exports: [RouterModule]

})

export class AppRoutingModule { }

